import { environment } from '../environments/environment';

export const DEBUG_INFO_ENABLED: boolean = !environment.production;
export const SERVER_API_URL = process.env.SERVER_API_URL;
export const VERSION = process.env.VERSION;
export const BUILD_TIMESTAMP = process.env.BUILD_TIMESTAMP;
